// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3o6Ie","largestCol":"styles_largestCol__2ooZJ","smallestCol":"styles_smallestCol__34JV3"};